module.exports = __webpack_public_path__ + "img/ic_super_feedback.09c68637.png";